import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";
import { NestingRunView } from "shared";

export const applyLayoutNesting = async (layoutId: string): Promise<NestingRunView> => {
  const response = await api.nesting.applyLayoutNesting.mutation({ params: { id: layoutId } });

  if (response.status === 200) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to apply layout nesting", response.status, response.body);
};
